// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kc-0";